import { Alert, Icon, IconButton } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormStatusEnum } from "../../_common/enum/forms/formStatus.enum";
import { FormStatusAdminEnum } from "../../_common/enum/forms/formStatusAdmin.enum";
import { IFilteringViewModel, ITableData } from "../../_common/interface/table";
import { CommonTable } from "../../_components/table/common.table";
import { PaperTableHeader } from "../../_components/table/header.table";
import { SearchTableHeader } from "../../_components/table/search.table";
import { TABLE_FILTER } from "../../_const/tableFilter.const";
import { getDateTime } from "../../_helpers/dateTime.helper";
import { removeSpaces } from "../../_helpers/format.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";


export function FormIndex() {

    const [data, setData] = useState<ITableData<any>>({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(true);
    const [filter, setFilter] = useState<IFilteringViewModel>({ ...TABLE_FILTER });

    const [search, setSearch] = useState<any>({
        formStatusId: "",
        userName: "",
        formTemplateTypeId: "",
        fromDate: "",
        toDate: ""
    });

    let navigate = useNavigate();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (<>
                    <IconButton
                        color="primary"
                        onClick={() => { (window as any).open("Forms/" + row.original.id || "", '_blank').focus(); }}>
                        <Icon>edit</Icon>
                    </IconButton>
                </>
                ),
            },
            {
                accessorKey: 'userName',
                header: 'User Name',
            },
            {
                accessorKey: 'completedDate',
                header: 'Date Completed',
                accessorFn: (rowData: any) => <>{rowData.completedDate ? getDateTime(rowData.completedDate) : "-"}</>,
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'formStatusAdminId',
                header: 'Form Admin Status',
                accessorFn: (rowData: any) => <>
                    {
                        rowData.formStatusAdminId == FormStatusAdminEnum.Approved ? <Alert severity="success">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                            rowData.formStatusAdminId == FormStatusAdminEnum.MissingItems ? <Alert severity="warning">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                                rowData.formStatusAdminId == FormStatusAdminEnum.Unprocessed ? <Alert severity="warning">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                                    rowData.formStatusAdminId == FormStatusAdminEnum.Cancelled ? <Alert severity="error">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                                        <>-</>}
                </>,
            },
            {
                accessorKey: 'formStatusId',
                header: 'Form Status',
                accessorFn: (rowData: any) => <>
                    {
                        rowData.formStatusId == FormStatusEnum.CompletedAwaitingApproval ? <Alert severity="success">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                                <></>}
                </>,
            },
            {
                accessorKey: 'formTypeName',
                header: 'Form Type',
            },

            {
                accessorKey: 'comment',
                header: 'Comments',
            },

        ],
        [],
    );

    useEffect(() => {
        if (filter) fetchData();
    }, [filter]);

    function handleChange(event: any) {
        setSearch((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };

    function fetchData() {
        setLoading(true);
        return formService.getAll({ ...filter, ...search })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>

            <PaperTableHeader title="Forms" />

            <SearchTableHeader inputs={[
                { label: "Ticket Number", name: "userName", onChange: handleChange, value: search.userName },
                { label: "Subject", name: "subjectName", type: "date", onChange: handleChange, value: search.fromDate },
                { label: "Status", name: "status", type: "date", onChange: handleChange, value: search.toDate },
            ]} />

            <CommonTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

        </>
    );

}
